export * from './search-placeholder'
export * from './cart-placeholder'
export * from './orders-placeholder'
export * from './kot-placeholder'
export * from './search-placeholder'
export * from './report-placeholder'
